import type { WeComApp, WeComModule } from "../api/wecomAppService";

/** 该模块是否已有一个启用中的企微应用。 */
export function hasEnabledWeComApp(apps: WeComApp[] | undefined, module: WeComModule): boolean {
  return (apps ?? []).some((a) => a.module === module && a.enabled !== false);
}
